export const calculateHDP = (hdp, fullState) => {
  //   console.log("from calculated hdp?", hdp);
    console.log("calling calculated hdp?" );
  
  const toNum = (v) => Number(String(v).replace(",", ".")) || 0;

  let result = { ...hdp };

  // const eingang_aufschlag = result?.eingangskalkulationAufschlag || 0;
  const rabattPerct = result?.DIPE || 0;
  const abschriftPercent = result?.abschriftPercent || 0;

  // console.log('abschriftpercent?', abschriftPercent)

  const avgEingangskalkulationAufschlag = (fullState?.PARTP?.[0]?.estimatedCalc + fullState?.PARTP?.[1]?.estimatedCalc)/2;

  const nachRabatt2 =
    (avgEingangskalkulationAufschlag * 100) /
    (100 +
      (avgEingangskalkulationAufschlag - (avgEingangskalkulationAufschlag * Number(rabattPerct)) / 100));
  const nachRabatt1 = (nachRabatt2 * 100) / (100 - nachRabatt2);
  const nachRabatt4 =
    ((100 + abschriftPercent) / 100) * nachRabatt2 - abschriftPercent;
  const nachRabatt3 = (nachRabatt4 * 100) / (100 - nachRabatt4);

  result.nachRabatt2 = nachRabatt2;
  result.nachRabatt1 = nachRabatt1;
  result.nachRabatt3 = nachRabatt3;
  result.nachRabatt4 = nachRabatt4;

  // console.log('nach rabatt 2?', nachRabatt2)

  const jahresVK = toNum(result.jahresVK);
  const eingangskalkulationAufschlag = toNum(
    result.eingangskalkulationAufschlag,
  );
  const DIPE = toNum(result.DIPE);

  if (jahresVK) {
    // const jahresEkWithoutDiscount =
    //   jahresVK / ((eingangskalkulationAufschlag + 100) / 100);

    // result.jahresEK =
    //   jahresEkWithoutDiscount - jahresEkWithoutDiscount * (DIPE / 100);
    const subJahresVK =
      (hdp?.jahresVK / (100 - fullState?.PARTP?.[1].percred)) *
        fullState?.PARTP?.[1].percValue +
      (hdp?.jahresVK / (100 - fullState?.PARTP?.[0].percred)) *
        (100 - fullState?.PARTP?.[1].percValue);

    // c1 = subJahresVK
    // c2 = jahresVK
    // c6 = fullState?.PARTP?.[1].percValue
    // c4 = fullState?.PARTP?.[0].estimatedCalcDisc
    // c16 = fullState?.PARTP?.[0].delivQuota
    // c5 = fullState?.PARTP?.[1].estimatedCalcDisc
    // c17 = fullState?.PARTP?.[1].delivQuota
    // c15 = DIPE
    // c11 = fullState?.PARTP?.[1].lugPlan

    // const aah =((C1*(100-C6)/100)*((100-C4)/100)/(C16/100)+(C1*C6/100)*((100-C5)/100)/($C$17/100))*(100-C15)/100

    const jahresEK =
      (((((subJahresVK * (100 - fullState?.PARTP?.[1].percValue)) / 100) *
        ((100 - fullState?.PARTP?.[0].estimatedCalcDisc) / 100)) /
        (fullState?.PARTP?.[0].delivQuota / 100) +
        (((subJahresVK * fullState?.PARTP?.[1].percValue) / 100) *
          ((100 - fullState?.PARTP?.[1].estimatedCalcDisc) / 100)) /
          (fullState?.PARTP?.[1].delivQuota / 100)) *
        (100 - hdp?.DIPE)) /
      100;

    result.subJahresVK = subJahresVK;
    result.jahresEK = jahresEK;
    result.abschriftAbsolut = subJahresVK - jahresVK;
    result.bestandAvg= (fullState?.PARTP?.[0]?.planStockAvail + fullState?.PARTP?.[1]?.planStockAvail);
    result.lugPlan = jahresVK / (result?.bestandAvg);
    console.log('resilt.bneftag?', result.bestandAvg)
    console.log('result luygplan?', result.lugPlan)

  } else {
    result.jahresEK = 0;
  }

  return result;
};

export const calculatePARTP = (partp = [], fullState) => {
  const toNum = (v) => Number(v) || 0;
  const round = (n) => Math.round(n * 100) / 100;

  console.log("partp calculation calling", partp);
  console.log('to num what?', toNum)

  const jahresEK = toNum(fullState?.HDP?.jahresEK);
  const jahresVK = toNum(fullState?.HDP?.jahresVK);

  return partp.map((row) => {
    const result = { ...row };

    // Total amount from percentage
    result.partAmount = round((toNum(row.percValue) / 100) * jahresEK);

    // Pre-order amount
    result.preAmount = round((toNum(row.prePerc) / 100) * result.partAmount);

    // Re-order amount
    result.reAmount = round(result.partAmount - result.preAmount);

    // result.outgoingCalc = round(
    //   ((result.estimatedCalc + 100) * (100 - percred)) / 100 - 100,
    // );

    // result.outgoingCalcDisc = round(
    //   (((100 * (100 - percred)) / 100 - (100 - result.estimatedCalcDisc)) /
    //     (100 - percred)) *
    //     100,
    // );

    const percred = toNum(result.percred);
    const estimatedCalcDisc = toNum(result.estimatedCalcDisc);

    result.outgoingCalcDisc =
      ((100 + percred) / 100) * estimatedCalcDisc - percred;

    result.outgoingCalc =
      (result?.outgoingCalcDisc * 100) / (100 - result?.outgoingCalcDisc);

    // c1 = subJahresVK
    // c2 = jahresVK
    // c6 = fullState?.PARTP?.[1].percValue
    // c4 = fullState?.PARTP?.[0].estimatedCalcDisc
    // c16 = fullState?.PARTP?.[0].delivQuota
    // c5 = fullState?.PARTP?.[1].estimatedCalcDisc
    // c17 = fullState?.PARTP?.[1].delivQuota
    // c15 = DIPE
    // c11 = fullState?.PARTP?.[1].lugPlan

    const bestand = (jahresVK * row?.percValue) / 100 / row?.lugPlan; // =C2*C6/100/C11 and C2*I6/100/C13
    result.planStockAvail = bestand;

    return result;
  });
};

export const calculateDTPRow = (row, fullState, partp) => {
  const toNum = (v) => Number(String(v).replace(",", ".")) || 0;
  const round = (n) => Math.round(n * 100) / 100;

  const jahresVK = toNum(fullState?.HDP?.jahresVK);

  const koll = partp?.find((x) => x?.typId === "KOLL");
  const nos = partp?.find((x) => x?.typId === "NOS");

  const kollVororderWert = toNum(koll?.preAmount);
  const kollNachorderWert = toNum(koll?.reAmount);

  const nosVororderWert = toNum(nos?.preAmount);
  const nosNachorderWert = toNum(nos?.reAmount);

  const result = { ...row };

  result.planWert = round((toNum(row.umsatzAnteile) * jahresVK) / 100);

  result.kollVororderWert = round(
    (toNum(row.kollVoorderPct) / 100) * kollVororderWert,
  );

  result.kollNachorderWert = round(
    (toNum(row.kollNachorderPct) / 100) * kollNachorderWert,
  );

  result.nosVororderWert = round(
    (toNum(row.nosVororderPct) / 100) * nosVororderWert,
  );

  result.nosNachorderWert = round(
    (toNum(row.nosNachorderPct) / 100) * nosNachorderWert,
  );

  result.planWertAbschriftenGesamt = round(
    (toNum(row.abschriftenAnteilePct) *
      toNum(fullState?.HDP?.abschriftAbsolut)) /
      100,
  );

  return result;
};

export const calculateHDPFromPARTP = (hdp, partp) => {
  console.log('calculateHDPFromPARTP calling')
  const toNum = (v) => Number(v) || 0;

  const koll = partp.find((r) => r.typId === "KOLL");
  const nos = partp.find((r) => r.typId === "NOS");

  const avg = (a, b) => (toNum(a) + toNum(b)) / 2;

  const avgEingangskalkulationAufschlag = avg(
    koll?.estimatedCalc,
    nos?.estimatedCalc,
  );

  const avgEingangskalkulationAbschlag = avg(
    koll?.estimatedCalcDisc,
    nos?.estimatedCalcDisc,
  );

  const avgAusgangskalkulationAufschlag = avg(
    koll?.outgoingCalc,
    nos?.outgoingCalc,
  );

  const avgAusgangskalkulationAbschlag = avg(
    koll?.outgoingCalcDisc,
    nos?.outgoingCalcDisc,
  );

  const totalWareAbschriftPercent = avg(koll?.percred, nos?.percred);

  return {
    ...hdp,

    eingangskalkulationAufschlag:
      ((avgEingangskalkulationAufschlag + 100) / (100 - toNum(hdp.DIPE))) *
        100 -
      100,

    eingangskalkulationAbschlag:
      100 -
      ((100 - avgEingangskalkulationAbschlag) * (100 - toNum(hdp.DIPE))) / 100,

    ausgangskalkulationAufschlag: avgAusgangskalkulationAufschlag,

    ausgangskalkulationAbschlag: avgAusgangskalkulationAbschlag,

    //   auslieferungsQuote: avg(koll?.delivQuota, nos?.delivQuota),

    //   lug: avg(koll?.lugPlan, nos?.lugPlan),

    //   abschriftPercent: totalWareAbschriftPercent,

    //   bestandAvg: avg(koll?.planStockAvail, nos?.planStockAvail),
  };
};

// export const calculateJahresEK = () => {

// };
